@if (customer) {
  <app-content-header [historyBack]="false" (backEvent)="onBack()" [headline]="customer.name"></app-content-header>
  <div class="d-flex align-items-center mb-3">
    <div class="h3">{{ 'customer_subscriptions_headline' | i18next }}</div>
    <button class="btn btn-outline-primary ml-auto" (click)="onAddSubscription()">
      {{ 'customer_view_add_subscription' | i18next }}
    </button>
  </div>
  <app-customer-navigation [id]="customerId"></app-customer-navigation>
  <app-filter (searchFilterChanged)="doFilter($event)" [placeholder]="'customer_subscription_search' | i18next"></app-filter>
  @if (!customerSubscriptions || customerSubscriptions.length === 0) {
    <div><i class="fas fa-info-circle red"></i>&nbsp;{{'customer_has_no_subscriptions' | i18next}}
  </div>
}
<div class="row align-items-stretch mt-2">
  @for (lic of customerSubscriptions; track lic) {
    <app-subscription-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [subscription]="lic" [detaillist]="true">
      @if (lic.isValid) {
        <button class="btn btn-outline-primary" [routerLink]="['/subscriptions', lic.appliance_id]">{{'app_details' | i18next}}</button>
      }
      @if (!lic.isValid) {
        <div upgrade>
          @if (lic.isOneTrial) {
            <button class="btn btn-outline-primary" (click)="doUpgradeExpiredOneTrial(lic.appliance_id)">{{'subscription_upgrade_plan' | i18next}}</button>
          }
        </div>
      }
    </app-subscription-card>
  }
</div>
}
